import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const TableSkeleton = ({ length }) => {
  const skeletonRows = length || 5;

  return (
    <>
      {skeletonRows &&
        [...Array(skeletonRows)].map((_, index) => (
          <tr key={index}>
            <td>
              <Skeleton width={30} height={40} />
            </td>
            <td>
              <Skeleton width={100} height={40} />
            </td>
            <td>
              <Skeleton width={150} height={40} />
            </td>

            <td>
              <Skeleton width={100} height={40} />
            </td>
            <td>
              <Skeleton width={120} height={40} />
            </td>
            <td>
              <Skeleton width={80} height={40} />
            </td>

            <td>
              <Skeleton width={60} height={40} />
            </td>
            <td>
              <Skeleton width={60} height={40} />
            </td>
            <td>
              <Skeleton width={30} height={40} />
              <Skeleton width={30} height={40} style={{ marginLeft: "10px" }} />
            </td>
          </tr>
        ))}
    </>
  );
};

export default TableSkeleton;
